// 画像系
const BASE_IMAGE_PATH = "/others";
export const BG_WAVE_PATH = `${BASE_IMAGE_PATH}/bg-auth-wave.svg`;
export const samplePlaceholderPath = (width: number, height: number) => `https://placehold.jp/${width}x${height}.png`;
export const GOOGLE_DRIVE_SVG_PATH = `${BASE_IMAGE_PATH}/Drive.svg`;
export const DROPBOX_SVG_PATH = `${BASE_IMAGE_PATH}/Dropbox.svg`;

// 本番、画像系
const PRD_BASE_IMAGE_PATH = "/images";
export const SIGN_UP_LAST_STEP_CONTENTS_PATH = `${PRD_BASE_IMAGE_PATH}/signup-desktop-step-3-image.png`;
export const SIGN_UP_STEP_3_ALERT_PATH = `${PRD_BASE_IMAGE_PATH}/signup-step-3-Alert.svg`;
export const SIGN_UP_STEP_3_IMAGE_PATH = `${PRD_BASE_IMAGE_PATH}/signup-step-3-image.png`;
export const SERVICE_MAIN_LOGO_PATH = `${PRD_BASE_IMAGE_PATH}/service-main-logo.png`;
// カラーミーショップ アプリストアの HINOME のページ。
// 審査中(非公開)は /apps/993 が 404 になるため、公開まではアプリストアのトップを開く。
// 公開後は "https://app.shop-pro.jp/apps/993" に差し替える
export const COLORME_APP_STORE_HINOME_PATH = "https://app.shop-pro.jp/";
export const COLORME_LOGO_PATH = `${PRD_BASE_IMAGE_PATH}/logo-colorme.png`;
export const SERVICE_OGP_IMAGE_PATH = `${PRD_BASE_IMAGE_PATH}/service-ogp-img.png`;
export const BENCHMARK_VIDEO_THUMBNAIL_PATH = `${PRD_BASE_IMAGE_PATH}/benchmark_video_thum_none.png`;
export const LECTURE_BANNER_IMAGE_PATH = `${PRD_BASE_IMAGE_PATH}/lecture-banner-laptop.jpg`;
// 無料診断のバナーの写真。空のあいだは写真なしで出す
export const DIAGNOSIS_BANNER_IMAGE_PATH = "";

// ダッシュボードのバナーから開く予約ページ（TimeRex）
export const DIAGNOSIS_RESERVATION_PATH = "https://timerex.net/s/hinome.naoya_7e98/d73d49da/";
export const LECTURE_RESERVATION_PATH = "https://timerex.net/s/hinome.naoya_7e98/15112ae0/";

// 資料系 ヘルプページ , 利用規約, プライバシーポリシー
export const HINOME_SNS_DAIKOU_PATH = "https://service.hinome.app/hinome-daikou";

const BASE_SERVICE_PATH = "https://hinome.notion.site/hinome/New_-258ada4a6e34463786f49a68c91e6f39";
export const SUPPORT_SERVICE_PATH = `${BASE_SERVICE_PATH}/`;
export const SERVICE_TERMS_PATH = "https://hinome.notion.site/1314a38f7678469e802bdf74513cb8f4";
// カラーミーショップ アプリストアの「ご利用方法ページURL」に出すマニュアル。
// 専用ページを公開したらここを差し替える（暫定でヘルプpage を指す）
export const COLORME_MANUAL_PATH = `${BASE_SERVICE_PATH}/`;
export const PRIVACY_POLICY_PATH = "https://hinome.notion.site/99b02af210f64b2ab68eda4081673b5d";

// 問い合わせ先。Zendesk を解約しても宛先が変わらないよう hinome.co.jp に寄せている
export const SUPPORT_EMAIL_PATH = "support@hinome.co.jp";
// SendGrid メールアドレス
export const SEND_GRID_EMAIL_PATH = "app@hinome.co.jp";
export const SEND_GRID_DASHBOARD_PATH = "https://app.sendgrid.com/";

// InstagramビジネスアカウントとFacebookページを連携する。
export const INSTAGRAM_BUSINESS_SETTING_PATH = "https://www.facebook.com/help/instagram/502981923235522";
export const FACEBOOK_PAGE_SETTING_PATH = "https://www.facebook.com/pages/creation/?ref_type=facebook_business_website";
export const LINKED_INSTAGRAM_FACEBOOK_PATH = "https://ja-jp.facebook.com/business/help/898752960195806";

// Instagramのベースパス
export const BASE_INSTAGRAM_SERVICE = "https://www.instagram.com/";
export const EDIT_INSTAGRAM_PATH = `${BASE_INSTAGRAM_SERVICE}accounts/edit/`;

// 管理者ダッシュボード系のパス
export const ADMIN_LOGIN_PATH = "/admin";
export const ADMIN_DASHBOARD_PATH = "/admin/dashboard";
export const ADMIN_USER_TABLE_PATH = "/admin/user-table";
export const ADMIN_WITHDRAWALS_PATH = "/admin/withdrawals";
export const ADMIN_INSTAGRAM_TABLE_PATH = "/admin/instagram-table";
export const ADMIN_PAID_CUSTOMERS_PATH = "/admin/paid-accounts/customers";
export const ADMIN_PAID_INSTAGRAMS_PATH = "/admin/paid-accounts/instagram-accounts";
export const ADMIN_PAID_EVENTS_PATH = "/admin/paid-accounts/events";
export const ADMIN_FEED_TABLE_PATH = "/admin/feed-table";
export const ADMIN_REEL_TABLE_PATH = "/admin/reel-table";
export const ADMIN_QUESTION_PATH = "/admin/question";
export const ADMIN_LEFT_AD_CONTENTS_MANAGER = "/admin/left-ad-contents-manager";
export const ADMIN_SEND_GRID_PATH = "/admin/sendgrid";
export const ADMIN_ORGANIZATION_PATH = "/admin/organization";
export const ADMIN_ORGANIZATION_ID_PATH = (id: string) => `/admin/organization/${id}`;
export const ADMIN_AD_ACCOUNTS_PATH = "/admin/ad-accounts";
export const ADMIN_AD_ACCOUNTS_CAMPAIGNS_PATH = "/admin/ad-accounts-campaigns";
export const ADMIN_WAVE_PATH = `${BASE_IMAGE_PATH}/polygon-scatter-haikei.svg`;
export const ADMIN_GOOGLE_ANALYTICS_PATH =
  "https://console.firebase.google.com/u/0/project/hinome-pj-prd/analytics/app/web:MTdkYzhjMGEtMTlmMS00OTg2LTkwYTQtNWM3NWZhMzY3Njc3/overview/~2F%3Ft%3D1652324485246&fpn%3D379766972260&swu%3D1&sgu%3D1&sus%3Dupgraded&cs%3Dapp.m.dashboard.overview&g%3D1";

export const ADMIN_CLARITY_PATH = "https://clarity.microsoft.com/projects";

// Corporate・組織向けダッシュボード系のパス
export const CORPORATE_LOGIN_PATH = "/corporate";
// 営業がそのまま開けるデモプレビュー。ログイン不要
export const CORPORATE_DEMO_PATH = "/corporate/demo";
export const CORPORATE_DASHBOARD_PATH = "/corporate/dashboard";
export const CORPORATE_MEMBERS_PATH = "/corporate/members";
export const CORPORATE_INVITE_PATH = "/corporate/invite";
export const CORPORATE_INVITE_TOKEN_PATH = (token: string) => `${CORPORATE_INVITE_PATH}/${token}`;
export const CORPORATE_INSTAGRAM_TABLE_PATH = "/corporate/instagram-table";
export const CORPORATE_FEED_TABLE_PATH = "/corporate/feed-table";
export const CORPORATE_REEL_TABLE_PATH = "/corporate/reel-table";
export const CORPORATE_STORY_TABLE_PATH = "/corporate/story-table";
export const CORPORATE_FEED_FIRST_PATH = "/corporate/feed-first";
export const CORPORATE_REEL_FIRST_PATH = "/corporate/reel-first";
export const CORPORATE_REPORT_PATH = "/corporate/report";
export const IMG_CORPORATE_BACKGROUND = `${BASE_IMAGE_PATH}/corporate/background-haikei.svg`;
export const IMG_CORPORATE_LOGO_AMIGO = `${BASE_IMAGE_PATH}/corporate/logo-amigo.png`;

// Instagramアカウント追加ガイド
export const ADD_INSTAGRAM_ACCOUNT_GUIDE_PATH = "https://hinome.notion.site/Instagram-2bc9e76bc7114d8f9ce958e5c06ebd14";

// Canvaのパス
export const COMMUNITY_PATH = "https://service.hinome.app/community-hinome";

// Hinome-replyのパス
export const HINOME_REPLY_PATH = "https://service.hinome.app/hinome-reply";

// HINOME Enterpriseのパス
export const HINOME_ENTERPRISE_PATH = "https://service.hinome.app/enterprise";

// HINOME（ユーザーアプリ）の新規登録。
// corp-dashboard は APP_ENV=corporate ビルドで認証が corporateAuthSync に分岐するため、
// 同一ビルド内の /auth/signup ではなく本番のユーザーアプリへ外部遷移させる。
export const HINOME_APP_SIGNUP_PATH = "https://hinome.app/auth/signup";
